import { render } from "./CloudHostingServices.vue?vue&type=template&id=74cdf78b&scoped=true"
import script from "./CloudHostingServices.vue?vue&type=script&lang=js"
export * from "./CloudHostingServices.vue?vue&type=script&lang=js"

import "./CloudHostingServices.vue?vue&type=style&index=0&id=74cdf78b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74cdf78b"]])

export default __exports__